<template>
  <b-modal
    id="failed-delete-account-modal"
    title="Failed to delete your account"
    centered
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="message">
      Sorry, we have encountered an error on deleting your account.
    </div>
    <template slot="modal-footer">
      <b-container>
        <b-row>
          <b-col>
            <b-btn
              class="ok-button"
              block
              pill
              variant="primary"
              @click="
                $root.$emit('bv::hide::modal', 'failed-delete-account-modal')
              "
            >
              Okay
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {};
</script>

<style lang="scss">
#failed-delete-account-modal {
  .modal-dialog {
    max-width: 381px !important;
  }
  .modal-header {
    padding-top: 20px;
    padding-bottom: 0;
    border-bottom-width: 0;
  }
  .modal-footer {
    border-top-width: 0;
    padding-bottom: 25px;
  }
  .modal-title {
    padding-left: 42px;
  }
  .modal-content {
    border-radius: 8px;
  }
  .message {
    color: #49545c;
    padding-left: 42px;
    padding-right: 42px;
    font-size: 14px;
    text-align: center;
  }
  button:focus {
    outline-width: 0;
  }
  .ok-button:hover,
  .ok-button:focus {
    background-color: #ff8a00;
    border-color: #ff8a00;
    filter: brightness(95%);
  }
}
</style>